import { Action } from '@ngrx/store';
import { LookupModel } from '../../../common/models/LookupModel';

export const GET_CURRENT_USER_SUBMITTING_ENTITIES_SUCCESS = '[Security] Get Current User Submitting Entities Success';

export class GetCurrentUserSubmittingEntitiesSuccessAction implements Action {
  readonly type = GET_CURRENT_USER_SUBMITTING_ENTITIES_SUCCESS;

  constructor(public payload: { submittingEntities: LookupModel[] }) { }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/GetCurrentUserSubmittingEntitiesSuccessAction.ts